import {isInViewport} from '../helpers/ElementHelper';

export class BindIdAnimationComponent {
  container = document.querySelector('.animated-boxes');

  animatedElements = document.querySelectorAll('.animated-boxes .asvg-lotties-animation-wrapper');

  elementDataObjects = [];

  animatedObjects = new Map();

  isInitiallyAnimated = false;

  swiper = null;

  constructor() {
    if (!this.animatedElements.length) {
      return;
    }

    this.initialize();
    this.addEventListeners();
  }

  async initialize() {
    this.setSwiper();

    this.createDataObjects();
    const isDestroyed = await this.destoryOldAnimations();
    if (isDestroyed) {
      this.createAnimatedElements();
    }
  }

  setSwiper() {
    const container = document.querySelector('.animated-boxes.swiper-container');
    if (!container) {
      return;
    }

    this.swiper = container.swiper;
  }

  addEventListeners() {
    window.addEventListener('scroll', (e) => this.windowScrollHandler(e));

    const swiper = this.swiper;
    if (swiper) {
      swiper.on('slideChange', (e) => this.swiperSlideChangedHandler(e));
    }
  }

  swiperSlideChangedHandler(e) {
    if (window.outerWidth > 768) {
      return;
    }

    const container = this.container;

    const slides = container.getElementsByClassName('animated-boxes__item');

    const animatedObjects = this.animatedObjects;

    const prevSlide = slides[e.previousIndex];
    const prevSlideAnimation = prevSlide.querySelector('.asvg-lotties-animation-wrapper');
    if (prevSlideAnimation) {
      let animatedObject = animatedObjects.get(prevSlideAnimation.getAttribute('id'));
      animatedObject.setDirection(-1);
      animatedObject.play();
    }

    const activeSlide = slides[e.realIndex];
    const activeSlideAnimation = activeSlide.querySelector('.asvg-lotties-animation-wrapper');
    if (activeSlideAnimation) {
      let animatedObject = animatedObjects.get(activeSlideAnimation.getAttribute('id'));
      animatedObject.setDirection(1);
      animatedObject.play();
    }
  }

  windowScrollHandler(e) {
    this.initialAnimationHandler();
  }

  initialAnimationHandler() {
    if (this.isInitiallyAnimated) {
      return;
    }

    if (window.outerWidth > 768) {
      return;
    }

    const container = this.container;

    if (!isInViewport(container)) {
      return;
    }

    const activeSlide = container.querySelector('.swiper-slide-active');
    if (!activeSlide) {
      return;
    }

    const animationWrapper = activeSlide.querySelector('.asvg-lotties-animation-wrapper');
    if (!animationWrapper) {
      return;
    }

    const animatedElementId = animationWrapper.getAttribute('id');
    const animatedObjects = this.animatedObjects;
    if (!animatedObjects.has(animatedElementId)) {
      return;
    }

    const animatedObject = animatedObjects.get(animatedElementId);
    animatedObject.play();

    this.isInitiallyAnimated = true;
  }

  createDataObjects() {
    let elementDataObjects = [];

    Array.from(this.animatedElements).forEach((animatedElement) => {
      let parent = animatedElement.closest('.animated-boxes__item');

      let elementDataObject = {
        container: animatedElement,
        parent: parent,
        path: animatedElement.dataset.path
      };

      elementDataObjects.push(elementDataObject);
    });

    this.elementDataObjects = elementDataObjects;
  }

  createAnimatedElements() {
    const elementDataObjects = this.elementDataObjects;
    if (!elementDataObjects.length) {
      return;
    }

    const direction = 1;

    const animatedObjects = this.animatedObjects;

    elementDataObjects.forEach((elementDataObject) => {
      let parent = elementDataObject.parent;

      let animatedObject = bodymovin.loadAnimation({
        container: elementDataObject.container,
        animType: 'svg',
        loop: false,
        autoplay: false,
        path: elementDataObject.path
      });

      animatedObject.setSpeed(3);

      animatedObjects.set(animatedObject.wrapper.getAttribute('id'), animatedObject);

      parent.addEventListener('mouseenter', (e) => {
        animatedObject.setDirection(direction);
        animatedObject.play();
      });

      parent.addEventListener('mouseleave', (e) => {
        animatedObject.setDirection(-direction);
        animatedObject.play();
      });
    });
  }

  async destoryOldAnimations() {
    return new Promise((resolve) => {
      let counter = 0;
      const interval = setInterval(async () => {
        counter++;

        const animations = lottie.getRegisteredAnimations();

        if (counter > 4) {
          clearInterval(interval);
          resolve(false);
        }

        if (!animations.length) {
          return;
        }

        animations.forEach((animation) => {
          let parent = animation.wrapper.closest('.animated-boxes__item');
          if (parent) {
            animation.destroy();
          }
        });

        clearInterval(interval);
        resolve(true);
      }, 100);
    });
  }
}